import { render, staticRenderFns } from "./PandiCheckupIndex.vue?vue&type=template&id=37a6ce4e&scoped=true&"
import script from "./PandiCheckupIndex.vue?vue&type=script&lang=js&"
export * from "./PandiCheckupIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a6ce4e",
  null
  
)

export default component.exports